<template>
    <v-row class="ml-4 align-center">
        <v-btn icon @click="$router.push({name: 'problemsList'})">
            <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
                <v-btn color="primary" depressed light class="pr-2" v-bind="attrs" v-on="on" >
                    {{problemName}}
                    <v-icon>mdi-chevron-down</v-icon>
                </v-btn>
            </template>
            <v-list>
                <v-list-item @click="renameShow = true"><v-list-item-title>Переименовать</v-list-item-title></v-list-item>
                <v-list-item><v-list-item-title>Удалить</v-list-item-title></v-list-item>
            </v-list>
        </v-menu>
        <v-spacer></v-spacer>
        <v-btn icon @click="logout"><v-icon>mdi-logout</v-icon></v-btn>
        <v-dialog v-model="renameShow" width="50%" @close="renameShow = false">
            <v-card>
                <v-card-text @submit.prevent="save">
                    <v-text-field
                        v-model="newName"
                        label="Название модели"
                    ></v-text-field>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn large color="primary" @click="save">Сохранить</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
import {truncate} from "@/utils";

export default {
    data() {
        return {
            renameShow: false,
            newName: false,
        }
    },
    created() {
        this.newName = this.problem?.name;
    },
    watch: {
        problem() {
            this.newName = this.problem?.name;
        },
    },
    methods: {
        logout() {
            this.$store.dispatch('logoutUser');
            this.$router.push({name: 'login'});
        },
        async save() {
            await this.$store.dispatch('problem/updateItemFields', {id: this.problem?.id, 'problem.name': this.newName});
            this.renameShow = false;
        }
    },
    computed: {
        problem() {
            return this.$store.state.problem.edit;
        },
        problemName() {
            return truncate(this.problem?.name, 48) || 'Проект';
        }
    }
}
</script>

<style scoped>

</style>
